<!-- <div class="orders py-4">
  <header class="orders-header has-border align-items-center d-flex pb-2 mb-4">
    <h1 class="m-0">Sales Order</h1>
    <h1 *ngIf="avaiableCredit" class="available-credit">
      Available Credit: {{ avaiableCredit | currency }}
    </h1>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </header>
  <form [formGroup]="saleOrderForm">
    <div class="row">
      <div class="col-3 border-end"></div>
      <div class="col-3 border-end"></div>
      <div class="col-6">
       
        </div>
      </div>
    </div>
    
  </form>
</div> -->

<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <form [formGroup]="saleOrderForm">
        <span
          class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
          <span class="col-auto d-flex gap-3 align-items-center">
            <h2 class="mb-0">Sales Order</h2>
            <span
              *ngIf="avaiableCredit"
              class="available-credit mb-0 client-badge">
              Available Credit: {{ avaiableCredit | currency }}
            </span>

            <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
              <jni-spinner></jni-spinner>
            </div>
          </span>
        </span>
        <div class="col-lg-12 adduser-container-hgt">
          <div class="m-3">
            <div class="mb-3">
              <div class="gray-bg-rounded">
                <jni-order-header
                  #orderHeader
                  [newSalesOrderCase]="true"
                  [parent]="saleOrderForm"
                  [bacList]="bacList"
                  [bacUserDefaultSelectionId]="bacUserDefaultSelectionId"
                  [brandingConsultantLists]="brandingConsultantLists"
                  [deliveryAddress]="deliveryAddress"
                  (bcSelectionEvent)="getBacForSalesOrder($event)"
                  (customerBillToObjectEvent)="getCustomerBillToData($event)"
                  [formErrors]="formErrors"
                  [customerPaymentMethodList]="customerPaymentMethodList"
                  (validationErrorEvent)="logValidationErrors()"
                  (smallLoaderEvent)="getLoaderStatus($event)"
                  (clearShipToEvent)="clearShipAddressForm()"
                  [customerBillToObject]="customerBillToObject"
                  (programDetailsEvent)="getProgramDetails($event)"
                  [orderType]="orderType"
                  (customerAccountChangedEvent)="
                    customerAccountChangedEvent($event)
                  "
                  (buyerChangeEvent)="buyerChangeEvent()"
                  (patchValueInCurrencyField)="
                    patchValueInCurrencyFieldEvent($event)
                  "></jni-order-header>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <div class="gray-bg-rounded">
                  <div class="row">
                    <jni-customer-address
                      [parent]="saleOrderForm"></jni-customer-address>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="gray-bg-rounded">
                  <div class="row">
                    <jni-ship-to-address
                      #shipTo
                      [parent]="saleOrderForm"
                      [deliveryAddress]="deliveryAddress"
                      [countryRegionList]="countryRegionList"
                      [customerBillToObject]="customerBillToObject"
                      (smallLoaderEvent)="getLoaderStatus($event)"
                      [showAddress]="false"
                      [formgroupName]="'shipTo'"
                      [formErrors]="formErrors"
                      (validationErrorEvent)="logValidationErrors()"
                      (melissaValidationIgnoreEvent)="
                        handleMelissaValidationIgnore($event)
                      "
                      [isShipToAddressFromOrder]="true">
                    </jni-ship-to-address>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="gray-bg-rounded mb-3">
                  <jni-invoice-emails
                    [invoiceListing]="invoiceListing"
                    [parent]="saleOrderForm"
                    (newLine)="addNewLine($event)"
                    (removeEmail)="removeEmail($event)"
                    *ngIf="saleOrderForm.value"></jni-invoice-emails>

                  <jni-order-details
                    #orderDetails
                    [parent]="saleOrderForm"
                    [shippingProductsList]="shippingProductsList"
                    [currencyList]="currencyList"
                    [formErrors]="formErrors"
                    (validationErrorEvent)="logValidationErrors()"
                    [applyCreditCardList]="applyCreditCardList"
                    [contactLists]="ClientAddresses"
                    [isCustomerPoRequiredField]="isCustomerPoRequiredField"
                    (contactListRefreshGrid)="contactListRefreshGrid($event)"
                    [customerBillToObject]="customerBillToObject"
                    [orderType]="orderType"></jni-order-details>
                </div>
              </div>

              <div class="d-flex gap-2 justify-content-end mb-3">
                <p-button
                  label="Cancel"
                  (onClick)="navigateToOrderListing()"
                  severity="secondary">
                </p-button>

                <p-button label="Save" (click)="onSubmit()" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </p-card>
  </div>
</div>
